module.exports = __webpack_public_path__ + "img/women.8ec09b71.jpg";